import React from 'react';
import { Grid, Card, CardContent, CardMedia, Typography, IconButton, useMediaQuery } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import MapIcon from '@mui/icons-material/Map';
import { useNavigate } from 'react-router-dom';

const StoreList = ({ stores, selectedStoreId }) => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:480px)'); // 画面幅が480px以下の場合に適用

  const handleCardClick = (storeName, isDisabled) => {
    if (!isDisabled) {
      navigate(`/store-entry/qr-code/${storeName}`);
    }
  };

  const handleInfoClick = (url) => {
    window.open(url, '_blank');
  };

  const handleMapClick = (address) => {
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    window.open(mapUrl, '_blank');
  };

  return (
    <Grid container spacing={2}>
      {stores.map((store) => {
        const isDisabled = store.status !== 'open';
        const isSelected = store.id === selectedStoreId;

        return (
          <Grid item xs={12} key={store.id}>
            <Card
              sx={{
                paddingLeft: '12px',
                paddingRight: '15px',
                marginLeft: '7px',
                marginRight: '7px',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                opacity: isDisabled ? 0.5 : 1,
                backgroundColor: isSelected ? 'rgba(0, 123, 255, 0.1)' : 'white',
                border: isSelected ? '2px solid #007bff' : 'none',
              }}
              onClick={() => handleCardClick(store.aws_name, isDisabled)}
            >
              <CardMedia
                component="img"
                sx={{ width: 100, height: 100, borderRadius: '8px' }}
                image={store.image_url || 'https://via.placeholder.com/100'}
                alt={store.display_name}
              />
              <CardContent sx={{ flex: '1 0 auto', position: 'relative' }}>
                <Typography variant="h6">{store.display_name}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {store.address}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {store.status === 'open' ? '開店中' : '閉店中'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  距離: {typeof store.distance === 'number' ? `${store.distance.toFixed(2)} km` : '不明'}
                </Typography>
                {isSmallScreen && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row', // 横に並べる
                      alignItems: 'center',
                      marginTop: '8px',
                      position: 'absolute',
                      right: 0,
                      top: 0,
                    }}
                  >
                    {store.site_url && (
                      <IconButton
                        aria-label="info"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleInfoClick(store.site_url);
                        }}
                      >
                        <InfoIcon />
                      </IconButton>
                    )}
                    {store.address && (
                      <IconButton
                        aria-label="map"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMapClick(store.address);
                        }}
                      >
                        <MapIcon />
                      </IconButton>
                    )}
                  </div>
                )}
              </CardContent>
              {!isSmallScreen && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row', // アイコンボタンを常に横に並べる
                    alignItems: 'center',
                    marginLeft: 'auto',
                  }}
                >
                  {store.site_url && (
                    <IconButton
                      aria-label="info"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleInfoClick(store.site_url);
                      }}
                    >
                      <InfoIcon />
                    </IconButton>
                  )}
                  {store.address && (
                    <IconButton
                      aria-label="map"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMapClick(store.address);
                      }}
                    >
                      <MapIcon />
                    </IconButton>
                  )}
                </div>
              )}
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default StoreList;
